import { Spinner } from '@/components/Spinner';
import { SearchInput } from '@/components/SearchInput';

interface TableSearchProps {
    search: string;
    isFetching: boolean;
    isLoading: boolean;
    onSearchChange: (search: string) => void;
}

export function TableSearch({
    search,
    isFetching,
    isLoading,
    onSearchChange,
}: TableSearchProps) {
    return (
        <div className="flex items-center gap-4">
            <SearchInput
                placeholder="Search..."
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                containerClassName="max-w-sm"
            />
            {isFetching && !isLoading && <Spinner />}
        </div>
    );
}
